<template>
  <div class="p-3 bg-white">
    <div id="EditTaskFormContainer" class="vs-con-loading__container">
      <shared-task-edit
        @editTaskSuccess="editTaskSuccess"
        :categoryOptions="categoryOptions"
        :progressStatusOptions="progressStatusOptions"
        :priorityOptions="priorityOptions"
        :visibilityOptions="visibilityOptions"
        :userOptions="userOptions"
        :projectOptions="projectOptions"
      ></shared-task-edit>

      <div class="text-center">
        <vs-button id="editTaskButton" class="m-2" color="primary" type="filled" @click.prevent="editTask">{{ $t('save') }}</vs-button>
        <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelEditTask">{{ $t('cancel') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Task from '@/models/Task'
import SharedTaskEdit from '@/views/Shared/Tasks/Edit'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Task.Edit',
  components: {
    SharedTaskEdit
  },
  data () {
    return {
      taskId: '',
      categoryOptions: [],
      progressStatusOptions: [],
      priorityOptions: [],
      visibilityOptions: [],
      userOptions: [],
      projectOptions: []
    }
  },
  mounted () {
    this.loadTask(this.$route.params.id)
  },
  methods: {
    async loadTask (taskId) {

      const response = await Task.findAll()

      this.categoryOptions = response.data.meta.options.categories
      this.progressStatusOptions = response.data.meta.options.progressStatuses
      this.priorityOptions = response.data.meta.options.priorities
      this.visibilityOptions = response.data.meta.options.visibilities
      this.userOptions = response.data.meta.options.users
      this.projectOptions = response.data.meta.options.projects

      EventBus.$emit('initEditTask', {id: taskId})

    },
    editTask () {
      EventBus.$emit('initUpdateTask')
    },
    editTaskSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_task_table')
      window.close()
    },
    cancelEditTask () {
      this.$windowOpenerHelper.notifyOpener('reload_task_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
